import i18next from 'i18next'
import { useTranslation } from 'react-i18next'
import Button from '../button/block'
import style from './block.module.scss'

function Page404() {
    const { t } = useTranslation()
    const getLanguage = () => i18next.language || window.localStorage.i18nextLng

    return (
        <div className={style.block}>
            <h1 className={style.text404}>404</h1>
            <h2>{t('Page non trouvée')}</h2>

            <Button
                text={t("Retour à la page d'accueil")}
                link={getLanguage() === 'fr' ? '/' : '/en'}
                aspect={'contained'}
                color={style.darkBlue}
                colorHover={style.blue}
                classNames={style.home}
            />
        </div>
    )
}

export default Page404
